import * as api from "@/common/api";
import { ClosetClothingRequest } from "../class";

// Body
export const getMyBody = async () => {
  const res = await api.get("/api/v1/closet/body", null, new api.HeaderOption(), true);
  return res.data;
};

export const saveBody = async (payload: any) => {
  const res = await api.put("/api/v1/closet/body", payload);
  return res.data;
};

// Body History
export const getBodyHistoryList = async () => {
  const res = await api.get("/api/v1/closet/body/history", null, new api.HeaderOption(), true);
  return res.data;
};

export const deleteBodyHistory = async (id: number) => {
  const res = await api.remove("/api/v1/closet/body/history/" + id);
  return res.data;
};

// Clothing
export const getClothingList = async (params?: any) => {
  const res = await api.get("/api/v1/closet/clothing/list", params || null, new api.HeaderOption(), true);
  return res.data;
};

export const getClothing = async (id: number) => {
  const res = await api.get("/api/v1/closet/clothing/" + id, null, new api.HeaderOption(), true);
  return res.data;
};

// 생성/수정은 성공여부(success)가 담긴 envelope 전체를 반환한다.
// (기존엔 res.data(payload)만 반환해 호출부의 success 체크가 항상 실패로 처리됐음)
export const createClothing = async (payload: ClosetClothingRequest) => {
  const res = await api.post("/api/v1/closet/clothing", payload);
  return res as any;
};

export const updateClothing = async (id: number, payload: ClosetClothingRequest) => {
  const res = await api.put("/api/v1/closet/clothing/" + id, payload);
  return res as any;
};

export const deleteClothing = async (id: number) => {
  const res = await api.remove("/api/v1/closet/clothing/" + id);
  return res.data;
};

export const getBrandSummary = async () => {
  const res = await api.get("/api/v1/closet/clothing/brand-summary", null, new api.HeaderOption(), true);
  return res.data;
};

// Public
export const getPublicStats = async () => {
  const res = await api.get("/api/v1/closet/public/stats", null, new api.HeaderOption(), false);
  return res.data;
};

export const getPublicClosetList = async () => {
  const res = await api.get("/api/v1/closet/public/list", null, new api.HeaderOption(), false);
  return res.data;
};

export const getPublicCloset = async (userId: number) => {
  const res = await api.get("/api/v1/closet/public/" + userId, null, new api.HeaderOption(), false);
  return res.data;
};
